import React from 'react';

const TrustedArtifactIcon = () => {
  return (
    <svg className="platform-icon allservices-icon" width="28" height="28" viewBox="0 0 38 38">
      <g id="uuid-a65c70ad-12b3-4cda-8a7e-1f2cfe14ffa5">
        <rect x="1" y="1" width="36" height="36" rx="9" ry="9" strokeWidth="0" />
        <path
          d="m28,2.25c4.27336,0,7.75,3.47664,7.75,7.75v18c0,4.27336-3.47664,7.75-7.75,7.75H10c-4.27336,0-7.75-3.47664-7.75-7.75V10c0-4.27336,3.47664-7.75,7.75-7.75h18m0-1.25H10C5.02944,1,1,5.02943,1,10v18c0,4.97057,4.02944,9,9,9h18c4.97056,0,9-4.02943,9-9V10c0-4.97057-4.02944-9-9-9h0Z"
          fill="#4d4d4d"
          strokeWidth="0"
        />
      </g>
      <g id="uuid-34aff54e-101c-43dd-a452-335e7514cb92">
        <path
          d="m10.625,12c0-.7583.6167-1.375,1.375-1.375h1c.34521,0,.625-.27979.625-.625s-.27979-.625-.625-.625h-1c-1.44727,0-2.625,1.17773-2.625,2.625v5c0,.7583-.6167,1.375-1.375,1.375-.34521,0-.625.27979-.625.625s.27979.625.625.625c.7583,0,1.375.6167,1.375,1.375v5c0,1.44727,1.17773,2.625,2.625,2.625h1c.34521,0,.625-.27979.625-.625s-.27979-.625-.625-.625h-1c-.7583,0-1.375-.6167-1.375-1.375v-5c0-.80029-.35986-1.51807-.92676-2,.56689-.48193.92676-1.19971.92676-2v-5Z"
          fill="#e00"
          strokeWidth="0"
        />
        <path
          d="m30,18.375c-.75781,0-1.375-.6167-1.375-1.375v-5c0-1.44727-1.17773-2.625-2.625-2.625h-1c-.34473,0-.625.27979-.625.625s.28027.625.625.625h1c.75781,0,1.375.6167,1.375,1.375v5c0,.80029.36035,1.51807.92676,2-.56641.48193-.92676,1.19971-.92676,2v5c0,.7583-.61719,1.375-1.375,1.375h-1c-.34473,0-.625.27979-.625.625s.28027.625.625.625h1c1.44727,0,2.625-1.17773,2.625-2.625v-5c0-.7583.61719-1.375,1.375-1.375.34473,0,.625-.27979.625-.625s-.28027-.625-.625-.625Z"
          fill="#e00"
          strokeWidth="0"
        />
        <path
          d="m24.44238,23.55811l-2.77374-2.77374c.59143-.77704.95636-1.7348.95636-2.78436,0-2.55029-2.0752-4.625-4.625-4.625-2.55029,0-4.625,2.07471-4.625,4.625s2.07471,4.625,4.625,4.625c1.04944,0,2.00726-.36493,2.78436-.95636l2.77325,2.77325c.12207.12207.28223.18311.44238.18311s.32031-.06104.44238-.18311c.24316-.24414.24316-.63965,0-.88379Zm-9.81738-5.55811c0-1.86084,1.51416-3.375,3.375-3.375,1.86133,0,3.375,1.51416,3.375,3.375s-1.51367,3.375-3.375,3.375c-1.86084,0-3.375-1.51416-3.375-3.375Z"
          fill="#fff"
          strokeWidth="0"
        />
      </g>
    </svg>
  );
};
export default TrustedArtifactIcon;
